import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaArrowRight } from 'react-icons/fa';
import logo from '../assets/Logo.png';

const navItems = [
    { label: 'Home', to: '/' },
    { label: 'Services', to: '/services' },
    { label: 'About', to: '/about' },
];

function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    const headerShellClassName = isHomePage
        ? 'fixed inset-x-0 top-4 z-50 px-4 text-white sm:px-6 lg:px-8'
        : 'sticky top-4 z-50 px-4 sm:px-6 lg:px-8';

    const shellInnerClassName = isHomePage
        ? 'mx-auto w-full max-w-7xl rounded-[1.75rem] border border-white/10 bg-slate-950/45 text-white shadow-[0_18px_50px_rgba(2,6,23,0.28)] backdrop-blur-2xl'
        : 'mx-auto w-full max-w-7xl rounded-[1.75rem] border border-slate-200/80 bg-white/88 text-slate-900 shadow-[0_18px_50px_rgba(15,23,42,0.12)] backdrop-blur-2xl';

    // const navLinkClassName = ({ isActive }) =>
    //     isHomePage
    //         ? `text-sm font-semibold transition ${isActive ? 'text-white' : 'text-white/75 hover:text-white'}`
    //         : `text-sm font-semibold transition ${isActive ? 'text-primary-700' : 'text-slate-600 hover:text-slate-950'}`;

    const navLinkClassName = ({ isActive }) => `text-sm font-semibold transition ${isActive ? 'text-white' : 'text-slate-300 hover:text-white'}`

    return (
        <header className={headerShellClassName}>
            <div className={`mx-auto w-full max-w-7xl rounded-[1.75rem] border border-white/10 bg-slate-950/45 text-white shadow-[0_18px_50px_rgba(2,6,23,0.28)] backdrop-blur-2xl`}>
                <div className="flex w-full items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
                    <Link to="/" className="flex items-center gap-3">
                        <img src={logo} alt="CET & RC" className="h-14 w-14 object-contain sm:h-16 sm:w-16" />
                        <p
                            className={`font-brand text-[14px] font-black uppercase tracking-[0.08em] text-white sm:text-[16px]`}
                        >
                            CET & RC
                        </p>
                    </Link>

                    <nav className="hidden items-center gap-8 lg:flex">
                        {navItems.map((item) => (
                            <NavLink key={item.label} to={item.to} className={navLinkClassName}>
                                {item.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/contact"
                            className="inline-flex items-center gap-2 rounded-full bg-primary-700 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-primary-700/25 transition hover:-translate-y-0.5 hover:bg-primary-800"
                        >
                            Enquire now
                            <FaArrowRight className="text-xs" />
                        </Link>
                    </nav>

                    <button
                        type="button"
                        onClick={() => setIsOpen((prev) => !prev)}
                        className={
                            isHomePage
                                ? 'inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white shadow-sm shadow-slate-950/20 lg:hidden'
                                : 'inline-flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-900 shadow-sm lg:hidden'
                        }
                        aria-expanded={isOpen}
                        aria-label="Toggle navigation"
                    >
                        {isOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                {isOpen ? (
                    <div className={isHomePage ? 'border-t border-white/10 bg-slate-950/90 px-4 py-5 lg:hidden' : 'border-t border-slate-200 bg-white px-4 py-5 lg:hidden'}>
                        <div className="mx-auto flex max-w-7xl flex-col gap-3 sm:px-2">
                            {navItems.map((item) => (
                                <NavLink
                                    key={item.label}
                                    to={item.to}
                                    onClick={() => setIsOpen(false)}
                                    className={({ isActive }) =>
                                        isHomePage
                                            ? `rounded-2xl px-4 py-3 text-sm font-semibold ${isActive ? 'bg-white/10 text-white' : 'text-white/75'}`
                                            : `rounded-2xl px-4 py-3 text-sm font-semibold ${isActive ? 'bg-primary-50 text-primary-700' : 'text-slate-700'}`
                                    }
                                >
                                    {item.label}
                                </NavLink>
                            ))}
                            <Link
                                to="/contact"
                                onClick={() => setIsOpen(false)}
                                className="mt-2 inline-flex items-center justify-center gap-2 rounded-2xl bg-primary-700 px-4 py-3 text-sm font-semibold text-white"
                            >
                                Enquire now
                                <FaArrowRight className="text-xs" />
                            </Link>
                        </div>
                    </div>
                ) : null}
            </div>
        </header>
    );
}

export default Header;
